module.exports = __webpack_public_path__ + "static/media/kare.83089053.webp";